import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/NutricionistaBrasileiraBrisbane";
import { pageHead, faqJsonLd, breadcrumbJsonLd } from "@/lib/seo";
import { SITE_URL } from "@/lib/seo";
const cityService = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Clara Camille - Nutricionista em Brisbane",
  description: "Nutricionista brasileira em Brisbane com atendimento presencial e online em português.",
  url: `${SITE_URL}/nutricionista-brasileira-brisbane`,
  parentOrganization: { "@id": `${SITE_URL}/#business` },
  areaServed: { "@type": "City", name: "Brisbane", containedInPlace: { "@type": "State", name: "Queensland" } },
  availableLanguage: ["Portuguese"],
  telephone: "+61423038977",
  priceRange: "$$",
};

export const Route = createFileRoute("/nutricionista-brasileira-brisbane")({
  head: () =>
    pageHead({
      title: "Nutricionista brasileira em Brisbane | Clara Camille",
      description:
        "Nutricionista brasileira em Brisbane com atendimento presencial e online em português. Planos alimentares com produtos locais. Consulta inicial gratuita.",
      path: "/nutricionista-brasileira-brisbane",
      ogDescription:
        "Atendimento presencial e online em português para brasileiros em Brisbane. Consulta inicial gratuita.",
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Nutricionista brasileira em Brisbane", path: "/nutricionista-brasileira-brisbane" },
        ]),
        cityService,
        faqJsonLd(faqItems),
      ],
    }),
  component: Page,
});
